module.exports = __webpack_public_path__ + "static/media/logo.664a40cb.png";